import { DateValidationError } from "@mui/x-date-pickers";
import { useMemo, useState } from "react";

export const useDatepickerErrorState = (): {
  setError: (error: DateValidationError | null) => void;
  errorMessage: string;
} => {
  const [error, setError] = useState<DateValidationError | null>(null);

  const errorMessage = useMemo(() => {
    switch (error) {
      case null:
        return "";
      case "maxDate":
        return "Date is too late";
      case "minDate":
        return "Date is too early";
      default: {
        return "Invalid date";
      }
    }
  }, [error]);

  return { setError, errorMessage };
};
